import { useQuery } from '@tanstack/react-query';
import { awaitJSON, MiscLambdaFetch } from '@src/utils/fetch-utils';
import { ProductRoadmapData } from './product-roadmap-constants';
import { normalizeProductRoadmapData } from './normalize-product-roadmap-data';

// Backed by the `misc` bpm-lambdas service's GET /roadmap route, which reads product-brain's
// generated roadmap data straight from its canonical S3 bucket on every request --
// regenerating + pushing that one file in product-brain is enough for this page to reflect the
// change, no tinuiti-frontend rebuild/redeploy needed. Requires the companion bpm-lambdas +
// bpm-infrastructure PRs to be deployed; until then this query errors and the page falls back
// to its "No product data loaded" state (see ProductRoadmap.tsx).
export const useProductRoadmapData = () =>
  useQuery<ProductRoadmapData>({
    meta: { suppressGlobalError: true },
    queryKey: ['productRoadmap'],
    // Normalized at the boundary: the payload is generated by product-brain and fetched at
    // runtime, so `ProductRoadmapData` is an assertion the compiler cannot check. A field whose
    // real shape drifts from the interface used to throw inside a component and blank the card
    // (see normalize-product-roadmap-data.ts). Coercing once here keeps that contained.
    queryFn: async () =>
      normalizeProductRoadmapData(await awaitJSON<unknown>(await MiscLambdaFetch('/roadmap')))
  });
